<template>
    <div style="display: flex; flex-direction: column; align-items: center; font-weight: 500;">
        <div style="width: 100%; max-width: 700px; padding: 0 32px; padding-top: 40px;">
            <div style="display: flex; justify-content: space-between; margin-bottom: 14px;">
                <div style="font-weight: 500; font-size: 14px; line-height: 16px;">{{ bodyText.total_find_position_cnt }}</div>
                <div style="font-weight: 700; line-height: 19px; text-decoration: underline;">{{position_try_count | comma}}</div>
            </div>
            <div style="display: flex; justify-content: space-between; margin-bottom: 14px;">
                <div style="font-weight: 500; font-size: 14px; line-height: 16px;">{{ bodyText.today_find_position_cnt }}</div>
                <div style="font-weight: 700; line-height: 19px; text-decoration: underline;">{{today_position_try_count | comma}}</div>
            </div>
            <div style="display: flex; justify-content: space-between; margin-bottom: 14px;">
                <div style="font-weight: 500; font-size: 14px; line-height: 16px;">{{ bodyText.test_pee }}</div>
                <div style="font-weight: 700; line-height: 19px; text-decoration: underline;">900원</div>
            </div>
            <div style="display: flex; justify-content: space-between;">
                <div style="font-weight: 500; font-size: 14px; line-height: 16px;">{{ bodyText.most_position_cnt }}</div>
                <div style="font-weight: 700; line-height: 19px; text-decoration: underline;">DM</div>
            </div>
            <!--<div style="margin-top: 40px; padding: 28px 0; background-color: #ededed; text-align: center;">광고 위치</div>-->
            <div style="margin-top: 40px;">
                <div style="text-align: center;">
                    <img style="width: 95px;" :src="require('@/assets/img/pro_uniform.png')" alt="">
                </div>
                <div style="margin-top: 40px; text-align: center;">
                    <div style="font-weight: 700;line-height: 24px;">{{ bodyText.pro_text.title }}</div>
                    <div style="font-size: 14px; line-height: 24px; margin-top: 8px;">{{ bodyText.pro_text.sub_title1 }}</div>
                    <div style="font-size: 14px; line-height: 24px; margin-top: 24px;">{{ bodyText.pro_text.sub_title2 }}</div>
                </div>
            </div>
            <div style="margin-top: 40px;">
                <div class="hide_scroll" style="display: flex; overflow-x: scroll; gap: 24px; margin: 0 -32px; margin-top: 20px; margin-bottom: 12px; padding: 0 32px;">
                    <div v-for="index in 4" :key="index">
                        <img style="width: 200px;" :src="require(`@/assets/img/position_pro_img${index}.png`)" alt="">
                    </div>
                </div>
                <div style="">
                    <CircleText>
                        <div style="font-weight: 500; font-size: 12px; line-height: 20px">{{ bodyText.pro_text.explanation1 }}</div>
                    </CircleText>
                    <CircleText>
                        <div style="font-weight: 500; font-size: 12px; line-height: 20px">{{ bodyText.pro_text.explanation2 }}</div>
                    </CircleText>
                    <CircleText>
                        <div style="font-weight: 500; font-size: 12px; line-height: 20px">{{ bodyText.pro_text.explanation3 }}</div>
                    </CircleText>
                    <CircleText>
                        <div style="font-weight: 500; font-size: 12px; line-height: 20px;">{{ bodyText.pro_text.explanation4 }}</div>
                    </CircleText>
                </div>
            </div>
            <div style="margin-top: 40px;">
                <div style="padding: 12px 20px; border-radius: 12px; display: flex; align-items: center; background-color: #F5F5F5; gap: 12px; margin-bottom: 12px;">
                    <img style="width: 20px;" :src="require('@/assets/img/method_1.png')" alt="">
                    <div style="font-size: 14px; line-height: 24px;">{{ bodyText.common_text.box1 }}</div>
                </div>
                <div style="padding: 12px 20px; border-radius: 12px; display: flex; align-items: center; background-color: #F5F5F5; gap: 12px; margin-bottom: 12px;">
                    <img style="width: 20px;" :src="require('@/assets/img/method_2.png')" alt="">
                    <div style="font-size: 14px; line-height: 24px;">{{ bodyText.common_text.box2 }}</div>
                </div>
                <div style="padding: 12px 20px; border-radius: 12px; display: flex; align-items: center; background-color: #F5F5F5; gap: 12px; margin-bottom: 12px;">
                    <img style="width: 20px;" :src="require('@/assets/img/method_3.png')" alt="">
                    <div style="font-size: 14px; line-height: 24px;">{{ bodyText.common_text.box3 }}</div>
                </div>
            </div>
            <!--<div style="text-align: center; margin-top: 40px;">-->
                <!--<div style="padding: 12px 20px; display: inline-block; background-color: #315997; border-radius: 100px;">-->
                    <!--<div style="display: flex; align-items: center; gap: 10px">-->
                        <!--<div @click="findPositionPro" style="font-weight: 700; font-size: 14px; line-height: 24px; color: #fff;">포지션 찾기 PRO 시작하기2</div>-->
                        <!--<img style="width: 16px;" :src="require(`@/assets/img/do_pro.png`)" alt="">-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->
            <div style="margin-top: 40px; text-align: center;">
                <div style="font-weight: 700;line-height: 24px;">{{ bodyText.common_text.position_info }}</div>
                <div style="font-size: 14px; line-height: 24px; margin-top: 8px;">{{ bodyText.common_text.explanation }}</div>
                <div style="margin-top: 20px;">
                    <img style="width: 190px;" :src="require('@/assets/img/pro_example.png')" alt="">
                </div>
            </div>
            <div style="padding-bottom: 40px; margin-top: 20px;">
                <div style="padding: 8px 12px; background-color: #f5f5f5; border-radius: 12px">
                    <div style="margin-bottom: 8px">
                        <div class="pos_title">{{ bodyText.position_list.attacker }}</div>
                        <div class="pos_wrap">
                            <div class="pos_txt">{{ bodyText.position_list.cf.name }}</div>
                            <div class="pos_main">{{ bodyText.position_list.cf.position }}</div>
                        </div>
                        <div class="pos_wrap">
                            <div class="pos_txt">{{ bodyText.position_list.ss.name }}</div>
                            <div class="pos_main">{{ bodyText.position_list.ss.position }}</div>
                        </div>
                        <div style="border: none" class="pos_wrap">
                            <div class="pos_txt">{{ bodyText.position_list.wf.name }}</div>
                            <div class="pos_main">{{ bodyText.position_list.wf.position }}</div>
                        </div>
                        <div style="height: 4px; background-color: #ededed; width: calc(100% + 20px); margin-left: -10px"></div>
                    </div>
                    <div style="margin-bottom: 8px">
                        <div class="pos_title">{{ bodyText.position_list.midfielder }}</div>
                        <div class="pos_wrap">
                            <div class="pos_txt">{{ bodyText.position_list.am.name }}</div>
                            <div class="pos_main">{{ bodyText.position_list.am.position }}</div>
                        </div>
                        <div class="pos_wrap">
                            <div class="pos_txt">{{ bodyText.position_list.cm.name }}</div>
                            <div class="pos_main">{{ bodyText.position_list.cm.position }}</div>
                        </div>
                        <div class="pos_wrap">
                            <div class="pos_txt">{{ bodyText.position_list.dm.name }}</div>
                            <div class="pos_main">{{ bodyText.position_list.dm.position }}</div>
                        </div>
                        <div style="border: none" class="pos_wrap">
                            <div class="pos_txt">{{ bodyText.position_list.mf.name }}</div>
                            <div class="pos_main">{{ bodyText.position_list.mf.position }}</div>
                        </div>
                        <div style="height: 4px; background-color: #ededed; width: calc(100% + 20px); margin-left: -10px"></div>
                    </div>
                    <div>
                        <div class="pos_title">{{ bodyText.position_list.defender }}</div>
                        <div class="pos_wrap">
                            <div class="pos_txt">{{ bodyText.position_list.cb.name }}</div>
                            <div class="pos_main">{{ bodyText.position_list.cb.position }}</div>
                        </div>
                        <div class="pos_wrap">
                            <div class="pos_txt">{{ bodyText.position_list.fb.name }}</div>
                            <div class="pos_main">{{ bodyText.position_list.fb.position }}</div>
                        </div>
                        <div style="border: none;" class="pos_wrap">
                            <div class="pos_txt">{{ bodyText.position_list.wb.name }}</div>
                            <div class="pos_main">{{ bodyText.position_list.wb.position }}</div>
                        </div>
                        <div style="height: 4px; background-color: #ededed; width: calc(100% + 20px); margin-left: -10px"></div>
                    </div>
                    <div>
                        <div class="pos_title" style="border: none; padding-top: 8px;">{{ bodyText.position_list.goalKeeper }}</div>
                        <div style="border: none; padding-bottom: 0; padding-top: 0;" class="pos_wrap">
                            <div class="pos_txt">{{ bodyText.position_list.gk.name }}</div>
                            <div class="pos_main">{{ bodyText.position_list.gk.position }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CircleText from '@/components/common/CircleText.vue';

export default {
    name: 'PositionPro',
    props: {
        showQr: {
            type: Function,
            default: () => {}
        }
    },
    components: {
        CircleText
    },
    computed: {
        bodyText() {
            return this.$i18n.messages[this.$i18n.locale].main_page.body;
        }
    },
    data(){
        return {
            position_try_count : 0,
            today_position_try_count : 0,
        }
    },
    methods : {
        findPositionPro(){
            this.$GlobalStore.addModal('MyPositionProMain')
        },
        async getPositionFindStat(){
            const res = await this.$Axios.get('/api/position/try/count');
            this.position_try_count = res.data.position_try_count
            this.today_position_try_count = res.data.today_position_try_count;
        }
    },
    created() {
        this.getPositionFindStat();
    }
}
</script>

<style scoped>
.pos_title {
    font-size: 12px;
    font-weight: 700;
    line-height: 24px;
    border-bottom: 1px solid #ededed;
    padding-bottom: 8px;
}

.pos_wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid #ededed
}

.pos_txt {
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    color: #808080;
}

.pos_main {
    font-size: 14px;
    font-weight: 700;
    line-height: 24px;
}
</style>